import styled from 'styled-components'
import { breakpoints } from '../../../../../constants'

export const StyledImg = styled.img`
	height: 100%;
`

export const StyledTotalContainer = styled.div`
	display: flex;
	flex-direction: column;
`

export const StyledMyOrder = styled.div`
	display: flex;
	height: 120px;
	width: 100%;
	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		width: 65%;
	}
`

export const StyledProductName = styled.p`
	font-size: 2.5rem;
	margin: 0;
`

export const StyledProductCode = styled.p`
	font-size: 1.5rem;
`

export const StyledButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	padding-bottom: 15px;
	padding-top: 30px;
`

export const StyledQuantityPointsContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-top: 15px;
	width: 100%;

	.quantity-order {
		display: flex;
		justify-content: center;
		margin-bottom: 20px;
	}

	.quantity-word {
		font-size: 18px;
	}

	.quantity-value {
		font-weight: bold;
	}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		flex-direction: row;
		justify-content: space-around;
		margin-top: 0px;
		width: 35%;

		.quantity-order {
			margin: 3px 10px;
			display: flex;
			align-items: flex-end;
		}

		.quantity-word {
			font-size: 1.8rem;
		}

		.quantity-value {
			font-weight: bold;
		}
	}
`

export const StyledProductInfo = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding-left: 15px;
`
